import { Textarea, TextInput } from "@mantine/core";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import DateTimePicker from "components/common/DateTimePicker";
import { UpdateTeaAddon } from "entities/tea_addons";

export const TeaAddonEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    getInputProps,
    saveButtonProps,
    refineCore: { queryResult },
  } = useForm<UpdateTeaAddon, HttpError, UpdateTeaAddon>({
    refineCoreProps: {
      redirect: "show",
    },
    initialValues: {
      shippable_at: new Date(),
      notes: "",
      name: "",
      chargebee_addon_id: "",
    },
  });

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      canDelete={false}
      title="Update tea addon"
    >
      <DateTimePicker
        type="date"
        label="Shippable At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("shippable_at")}
      />
      <TextInput
        defaultValue=""
        mt="sm"
        label="Name"
        {...getInputProps("name")}
      />
      <TextInput
        defaultValue=""
        mt="sm"
        label="ChargeBee Addon Id"
        {...getInputProps("chargebee_addon_id")}
      />
      <Textarea
        defaultValue=""
        mt="sm"
        label="Notes"
        {...getInputProps("notes")}
      />
    </Edit>
  );
};
